import api from "apis/watches";
import { WebApiRequest, HTTP_GET, HTTP_POST, HTTP_DELETE } from "tools/webservice";

export const getWatches = (internetUserId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getWatches(internetUserId),
  successCallback,
  mountedRef,
});

export const getAvailableWatches = (internetUserId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getAvailableWatches(internetUserId),
  successCallback,
  mountedRef, 
});

export const updateWatches = (internetUserId, enableCaseEventIds, disableCaseEventIds, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  payload: {
    internetUserId: internetUserId,
    enableCaseEventIds: enableCaseEventIds,
    disableCaseEventIds: disableCaseEventIds,
  },
  endpoint: api.updateWatches(internetUserId),
  successCallback: successCallback,
  mountedRef: mountedRef,
});

export const watchGroupDelete = (groupId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_DELETE,
  endpoint: api.watchGroupDelete(groupId),
  successCallback,
  mountedRef, 
});

export const getCaseWatches = (controlNumber, internetUserId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getCaseWatches(controlNumber, internetUserId),
  successCallback,
  mountedRef,
});

export const updateCaseWatches = (controlNumber, internetUserId, enableCaseEventIds, disableCaseEventIds, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  payload: {
    controlNumber: controlNumber,
    internetUserId: internetUserId,
    enableCaseEventIds: enableCaseEventIds,
    disableCaseEventIds: disableCaseEventIds,
  },
  endpoint: api.updateCaseWatches(controlNumber, internetUserId),
  successCallback: successCallback,
  mountedRef: mountedRef,
});